/**
 * Desc: 财务舞弊表象提示
 */
import style from '../common.scss';
import React, { PureComponent } from 'react';
import { Table, Modal } from 'antd';
import { PAGE_SIZE } from '../../../../constants/common';
import { addDataIndex } from '../../../../utils/util';
import { fraundSurfaceTip, netProfit } from '../../../../services/financialPicture/fraudAnalysis';
import { commonRequest } from '../../common/commons';
import GroupBox from '../../../common/groupBox/GroupBox';
import ReturnOnEquity from './details/ReturnOnEquity'; // 多年微利
import NetProfitBar from './details/NetProfitBar'; // 长期一年亏损一年盈利
import CurrentLiabilities from './details/CurrentLiabilities'; // 高银行存款和高负债
import ReportYearAudit from './details/ReportYearAudit'; // 审计存在非标意见-年报审计
// import TaragetCompany from './details/TaragetCompany'; // 在披露时间截止披露信息
// import ReduceShareholder from './details/ReduceShareholder'; // 股东减持情况
import CollectNum from './details/CollectNum'; // 应收账款长期挂账
import LargeAbnormal from './details/LargeAbnormal'; // 大额/异常减值
import LongEquityInvestment from './details/LongEquityInvestment'; // 长期投资异常变动
import IntangibleAssets from './details/IntangibleAssets'; // 无形资产异常变动
import TaxException from './details/TaxException'; // 税费异常
import PayFreeCash from './details/PayFreeCash'; // 支付与其他经营活动现金
import ReciveFreeCash from './details/ReciveFreeCash'; // 收到的与其他经营活动现金
// import ManagerDimission from '../../common/sameDetail/ManagerDimission'; // 董监高总体辞职率高
import MainSupplierChange from './details/MainSupplierChange'; // 主要供应商变动较大
import MainClientChange from './details/MainClientChange'; // 主要客户变动较大
import ResearchCost from './details/ResearchCost'; // 研发费用占营业收入比重异常
import ResearchPerson from './details/ResearchPerson'; // 研发人员数量占比异常
import DeferredIncomeTax from './details/DeferredIncomeTax'; // 递延所得税情况
// import ChangePerformance from './details/ChangePerformance'; // 业绩变脸
import EarningsOversize from './details/EarningsOversize'; // 投资收益占净利润比过大
import Prepayments from './details/Prepayments'; // 预付款高账龄占比较大
// import FirstYearNetProfit from './details/FirstYearNetProfit'; // 上市首年业绩大幅下滑
import AssociatedSecurity from './details/AssociatedSecurity'; // 关联担保额
import SupplierIsCustomer from './details/SupplierIsCustomer'; // 同为供应商和客户

export default class FraudSurfaceTip extends PureComponent {
    constructor(props) {
        super(props);
        this.detailSet = {
            // '10': ChangePerformance, // 下个版本开发
            '11': PayFreeCash,
            '12': ReciveFreeCash,
            '13': MainSupplierChange,
            '14': EarningsOversize,
            '15': MainClientChange,
            '16': ResearchCost,
            '17': ResearchPerson,
            '18': DeferredIncomeTax,
            '19': Prepayments,
            // '20': FirstYearNetProfit, // 下个版本开发
            '21': ReturnOnEquity,
            '22': NetProfitBar,
            '23': CurrentLiabilities,
            '24': ReportYearAudit,
            // '25': TaragetCompany, // 下个版本开发
            // '26': ReduceShareholder,  // 下个版本开发
            '27': CollectNum,
            '28': TaxException,
            '29': AssociatedSecurity,
            '30': LargeAbnormal,
            '31': LongEquityInvestment,
            '32': IntangibleAssets,
            '33': SupplierIsCustomer
            // '144': ManagerDimission
        };
        this.state = {
            visible: false,
            loading: false,
            pageNum: 1,
            pageSize: 10,
            activeItem: '',
            tableData: []
        };
    }

    componentDidMount() {
        this.surfaceTipPort();
    }

    showModal = (d) => {
        this.setState({ visible: true, activeItem: d });
    };

    hideModal = () => {
        this.setState({ visible: false });
    };

    // 财务舞弊表象提示
    surfaceTipPort = () => {
        this.setState({
            loading: true
        });
        const { pageNum, pageSize } = this.state;
        fraundSurfaceTip(commonRequest()).then((data) => {
            data = data || {};
            // let test = (data.list).push({ exName: '666666', explain: '8888888888888', id: '28' });
            // console.log('yyyyyyyyyyy', test);
            this.setState({
                tableData: addDataIndex(data.list || [], pageNum, pageSize),
                loading: false
            });
        }).catch(() => {
            this.setState({
                loading: false
            });
        });
    };

    getColumns = () => {
        return [{
            title: '序号',
            dataIndex: 'index',
            width: 60
        }, {
            title: '经营隐患',
            dataIndex: 'exName',
            width: 260
        }, {
            title: '业务解读',
            dataIndex: 'explain'                                                                                                      
        }, {
            title: '操作',
            dataIndex: 'id',
            width: 80,
            render: (v, d) => d.id ? <a href="javascript:void(0)" onClick={() => this.showModal(d.id)}>查看详情</a> : ''
        }];
    };

    render() {
        const { visible, tableData, activeItem, loading } = this.state;
        let Component = this.detailSet[activeItem];
        return (
            <GroupBox
                id="fraud-presentation"
                title="财务舞弊表象提示"
                className={style.abnormalOperation}
            >
                <Table
                    bordered
                    loading={loading}
                    className="table-margin"
                    rowKey="index"
                    dataSource={tableData}
                    columns={this.getColumns()}
                    pagination={tableData.length > PAGE_SIZE}
                />
                <Modal
                    width={900}
                    visible={visible}
                    onCancel={this.hideModal}
                    footer={null}
                >
                    {Component && <Component id={activeItem} server={netProfit} />}
                </Modal>
            </GroupBox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialFraudAnalysis/subComponents/FraudSurfaceTip.jsx